export default {
  toasts: {
    failed_to_create_website: 'Falha ao criar website',
  },
  steps: {
    information: 'Informação',
    template: 'Modelo',
  },
  buttons: {
    next: 'Seguinte',
    previous: 'Anterior',
    create_website: 'Criar Website',
    preview_about_us: 'Sobre Nós (Pré-visualização)',
  },
  about_us_modal: {
    title: 'Sobre Nós (Pré-visualização)',
  },
  error_messages: {
    missing_fields:
      'Alguns campos obrigatórios estão em falta. Por favor, preencha toda a informação necessária antes de continuar.',
  },
};
